<template>
  <div>
    <div class="main-section setting-page">
      <div class="content pdt100 fpnc">
        <!-- <el-card>
                    <h1 class="heading-text">Gengeral Setting</h1>

                    <el-form>
                        <el-form-item class="toggle-switch" label="Active Time">
                            <el-switch
                            v-model="getactivetime"
                            @change="setActiveTime()"
                            active-value="1"
                            inactive-value="0">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </el-card> -->
        <!-- eo general settings -->

        <!-- <div class="divider"></div> -->
        <el-card>
          <form class="content-form">
            <el-form>
              <el-form-item
                class="toggle-switch"
                label="Get Update Message"
                prop="delivery"
              >
                <el-switch
                  v-model="getmessage"
                  @change="setNotiStatus()"
                  active-value="1"
                  inactive-value="0"
                >
                </el-switch>
              </el-form-item>

              <div v-if="getmessage == true" style="padding-top:10px;">
                <div v-if="loadingusers == true" class="loading">
                  <img src="~styles/img/load.gif" alt="" />
                </div>

                <div v-if="loadingusers == false" class="contact-header">
                  <h1 class="heading-text">
                    Notification Receiver
                    <span @click="addnotireceiver = true"
                      ><i class="glyphicon glyphicon-plus"></i> Add new
                      receiver</span
                    >
                  </h1>
                </div>

                <div
                  v-if="loadingusers == false"
                  class="contact-table table-responsive"
                >
                  <table class="table list-table spacing-table del-table">
                    <tbody class="custom-table">
                      <template>
                        <tr
                          class=""
                          v-for="receivers in getreceivers"
                          :key="receivers.id"
                        >
                          <td>{{ receivers.phone }}</td>

                          <td>
                            <a @click="updatenotireceiver()">
                              <i
                                :data-id="receivers.id"
                                :data-phone="receivers.phone"
                                class="el-icon-edit"
                              ></i>
                            </a>

                            <a class="del-user" @click="delUser()">
                              <i class="el-icon-delete"></i>
                            </a>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-form>
          </form>
        </el-card>
        <!-- eo get update message -->

        <!-- <div class="divider"></div>
                <el-card>
                    <form class="content-form">
                        <el-form>

                            <div style="padding-top:10px;">
                                
                                <div v-if="loadingmessage == true" class="loading">
                                    <img src="~styles/img/load.gif" alt="">
                                </div>

                                <div class="contact-header">
                                    <h1 class="heading-text">Auto Message <span @click="addnotireceiver = true"><i class="glyphicon glyphicon-plus"></i> Add new message</span></h1>
                                </div>

                                <div v-if="loadingmessage == false" class="contact-table table-responsive">
                                    <table class="table list-table spacing-table del-table">
                                        <tbody class="custom-table">
                                            <template>
                                                <tr
                                                class=""
                                                v-for="automessage in auto_message"
                                                :key="automessage.id">
                                                    <td>{{ automessage.message }}</td>

                                                    <td>
                                                        <a
                                                        @click="updatenotireceiver()"
                                                        >
                                                            <i
                                                            :data-id="automessage.id"
                                                            :data-message="automessage.message"
                                                            class="el-icon-edit"></i>
                                                        </a>

                                                        <a
                                                        class="del-user"
                                                        @click="delMessage()">
                                                            <i
                                                            class="el-icon-delete"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </el-form>

                    </form>
                </el-card> -->
      </div>
    </div>

    <div class="footer">
      <p>© ekghanti 2018</p>
    </div>

    <!-- dialog for adding receiver -->
    <el-dialog
      title="Add New Receiver"
      :visible.sync="addnotireceiver"
      width="50%"
    >
      <form class="content-form">
        <div class="form-group">
          <label for="">Number:</label>
          <input
            type="text"
            class="form-control"
            v-model="addreceivers.phone"
            autofocus
          />
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addnotireceiver = false">Cancel</el-button>
        <el-button type="primary" @click="saveNewReceiver()">Save</el-button>
      </span>
    </el-dialog>

    <!-- dialog for editing receiver -->
    <el-dialog title="Edit Receiver" :visible.sync="updatereceiver" width="50%">
      <form class="content-form">
        <div class="form-group">
          <label for="">Number:</label>
          <input
            type="text"
            class="form-control"
            v-model="editreceivers.phone"
            autofocus
          />
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="updatereceiver = false">Cancel</el-button>
        <el-button type="primary" @click="editNewReceiver()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  setnotificationsetting,
  getnotificationsetting,
  updatenotificationreceivers,
  getnotificationreceivers,
  setnotificationreceivers,
  getHeader
} from "./../../config";

export default {
  data() {
    return {
      loadingusers: true,
      addnotireceiver: false,
      updatereceiver: false,
      getmessage: "",
      loadingmessage: false,

      getactivetime: "0",

      getreceivers: {
        id: "",
        phone: ""
      },

      editreceivers: {
        id: "",
        phone: ""
      },

      addreceivers: {
        phone: ""
      },

      auto_message: [
        { id: "001", message: "First Auto Message" },
        { id: "002", message: "Second Auto Message" },
        { id: "003", message: "Third Auto Message" }
      ]
    };
  },

  methods: {
    setNotiStatus() {
      // alert(this.getmessage)
      axios
        .post(
          setnotificationsetting,
          { sms: this.getmessage },
          { headers: getHeader() }
        )
        .then(Response => {
          if ((Response.data.errror = "false")) {
            this.$notify({
              group: "foo",
              type: "success",
              title: "Success",
              text: "Notificaiton Setting Changed."
            });
            this.loadingusers = true;
            this.$nextTick(function() {
              this.refreshreceiver();
              this.$nextTick(function() {
                this.loadingusers = false;
              });
            });
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong."
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    refreshreceiver() {
      axios
        .get(getnotificationreceivers, { headers: getHeader() })
        .then(Response => {
          if ((Response.data.errror = "false")) {
            this.getreceivers = Response.data.data;
          }
        });
    },

    updatenotireceiver() {
      this.updatereceiver = true;
      this.editreceivers.id = event.target.dataset.id;
      this.editreceivers.phone = event.target.dataset.phone;
    },

    editNewReceiver() {
      if (!this.editreceivers.phone) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "Error",
          text: "Cant add empty Number."
        });
      } else {
        axios
          .patch(
            updatenotificationreceivers + this.editreceivers.id,
            this.editreceivers,
            { headers: getHeader() }
          )
          .then(Response => {
            if ((Response.data.errror = "false")) {
              this.$notify({
                group: "foo",
                type: "success",
                title: "Success",
                text: "Receiver has been successfully edited."
              }),
                (this.updatereceiver = false),
                this.$nextTick(function() {
                  this.refreshreceiver();
                });
            }
          })
          .catch(function(error) {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong."
            });
          });
      }
    },

    saveNewReceiver() {
      if (!this.addreceivers.phone) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "Error",
          text: "Cant add empty Number."
        });
      } else {
        axios
          .post(setnotificationreceivers, this.addreceivers, {
            headers: getHeader()
          })
          .then(Response => {
            // console.log(Response)
            if ((Response.data.errror = "false")) {
              this.$notify({
                group: "foo",
                type: "success",
                title: "Success",
                text: "Receiver has been successfully added."
              }),
                (this.addnotireceiver = false),
                this.$nextTick(function() {
                  (this.addreceivers.phone = ""), this.refreshreceiver();
                });
            }
          });
      }
    }
  },

  mounted() {
    axios
      .get(getnotificationsetting, { headers: getHeader() })
      .then(Response => {
        if ((Response.data.errror = "false" && Response.data.data.sms == "1")) {
          this.getmessage = Response.data.data.sms;
          this.loadingusers = true;
          this.$nextTick(function() {
            this.refreshreceiver();
            this.$nextTick(function() {
              this.loadingusers = false;
            });
          });
        }
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/setting.vue